
















































import { Component, Vue, PropSync, Emit } from 'vue-property-decorator'
import { DropDownController } from '@/services/request.service'
import { getLocale } from '@/utils/utils'

@Component
export default class StaffEditor extends Vue {
  @PropSync('staff', {
    type: Object,
    default: () => ({
      email: '',
      name: '',
      enName: '',
      roleId: undefined,
    }),
  })
  private staffEditor!: any
  private roles: Array<any> = []

  private get rules(): any {
    return {
      email: [
        { required: true, message: this.$tc('staffMgmt.enterLoginEmail'), trigger: 'change' },
        { type: 'email', message: this.$tc('staffMgmt.enterCorrectEmail'), trigger: 'blur' },
      ],
      name: [{ validator: this.validateZhName, trigger: 'change' }],
      enName: [{ validator: this.validateEnName, trigger: 'change' }],
      roleId: [{ required: true, message: this.$tc('staffMgmt.selectRole'), trigger: 'change' }],
    }
  }

  private get locale(): string {
    return getLocale()
  }

  private created(): void {
    this.getRoles()
  }

  private validateZhName(rule, value, callback) {
    if (!value && !this.staffEditor.enName) {
      callback(new Error(this.$tc('staffMgmt.emptyName')))
    } else {
      const staffEditor = this.$refs.staffEditor as any
      staffEditor.clearValidate('enName')
      callback()
    }
  }
  private validateEnName(rule, value, callback) {
    if (!value && !this.staffEditor.name) {
      callback(new Error(this.$tc('staffMgmt.emptyName')))
    } else {
      const staffEditor = this.$refs.staffEditor as any
      staffEditor.clearValidate('name')
      callback()
    }
  }

  private getRoles(): void {
    DropDownController.queryRoleListAdmin()
      .then(res => {
        this.roles = res.data
      })
      .catch(err => {
        console.error(err)
      })
  }

  @Emit('cancel')
  private cancel(): void {}

  private submit(): void {
    const staffEditor = this.$refs.staffEditor as any
    staffEditor.validate(valid => {
      if (valid) {
        this.confirm()
      } else {
        return false
      }
    })
  }

  @Emit('confirm')
  private confirm(): void {}
}
